// Simple example of a React "smart" component

import { connect } from 'react-redux';
import MyArtists from '../components/MyArtists';
import * as actions from '../actions/myArtistsActionCreators';

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = (state) => ({
  csrfToken: state.csrfToken,
  team: state.team,
  currentUser: state.currentUser,
  dataTableTitle: state.dataTableTitle,
  dataTableDataSource: state.dataTableDataSource,
  dataTableOrder: state.dataTableOrder,
  dataTableColumns: state.dataTableColumns,
  dataTableEl: state.dataTableEl,
  artistOwnerships: state.artistOwnerships
});

const mapDispatchToProps = (dispatch) => {
  return {
    artistOwnershipsChanged: (artistOwnerships) => dispatch(actions.artistOwnershipsChanged(artistOwnerships))
  }
};

// Don't forget to actually use connect!
// Note that we don't export HelloWorld, but the redux "connected" version of it.
// See https://github.com/reactjs/react-redux/blob/master/docs/api.md#examples
export default connect(mapStateToProps, mapDispatchToProps)(MyArtists);
